import { Injectable } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private menuOpenState = new BehaviorSubject<boolean>(false);
  public menuOpen$: Observable<boolean> = this.menuOpenState.asObservable()

  constructor() {}

  setMenuOpen(isOpen: boolean): void {
    this.menuOpenState.next(isOpen)
  }
}
